
import React from "react";

interface DualAssessmentWarningProps {
  show: boolean;
  selfHasGraph: boolean;
  workHasGraph: boolean;
}

const DualAssessmentWarning: React.FC<DualAssessmentWarningProps> = ({
  show,
  selfHasGraph,
  workHasGraph,
}) =>
  show ? (
    <div className="mb-12 w-full">
      <div className="text-gray-700 bg-gray-50 border border-gray-300 px-6 py-4">
        <strong>Note:</strong> Only
        {!selfHasGraph && !workHasGraph && " no profiles"}
        {selfHasGraph && !workHasGraph && " Self"}
        {!selfHasGraph && workHasGraph && " Work"}
        {' '}graph is available. Please check with your administrator if you completed both portions of the assessment.
      </div>
    </div>
  ) : null;

export default DualAssessmentWarning;
